import React, { useEffect, useState } from 'react';
import Universalpageheader from '../Headers/universalpageheader';
import { useLocation } from 'react-router-dom';
import fetch from '../Utils/fetch';
import Productcard from '../Products/productcard';
import { CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Searchbar from '../Components/searchbar';
import { Productcardskeleton } from '../Components/skeletons';


function Categoryitems() {
    const dispatch = useDispatch();
    const subProducts = useSelector((state) => state.subProducts.data);
    const location = useLocation()
    const [error, setError] = useState('');
    const category = location.state?.category;


    const [loading, setloading] = useState(true);
    const [showsearchbar, setshowsearchbar] = useState(false);

    const [displayeditems, setdisplayeditems] = useState([]);

    useEffect(() => {
        loadFromSubCategory()
        window.scrollTo(0, 0);
    }, [category]);

    function loadFromSubCategory() {
        setloading(true);
        fetch
            .get('getProductsGroup', { group_code: category.item_group })
            .then((res) => {
                console.log(res)
                setloading(false);
                setdisplayeditems(res.list.itemsarray)
            })
            .catch((err) => {
                setloading(false);
                setError(err.message);
            });
    }


    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={category?.group_name} withbackicon={true} />
            {/* {loading && <div className='mainloadingdiv'><CircularProgress /></div>} */}
            <div >
                <div className='wrapfourcards'>
                    {displayeditems?.length > 0 ? displayeditems.map((val, key) => {
                        return (
                            <Productcard product={val} key={key} showoffer={true} />
                        )
                    }) :
                        Array.from({ length: 20 }, (_, index) => (
                            <Productcardskeleton key={index} />
                        ))}
                </div>
            </div>
        </div>
    );
}


export default Categoryitems;
